<template>
  <div>
    <dx-grid
      :url="url"
      :columns="columns"
      :title="title"
      ref="grid"
      :actions="actions"
      :beforeSetupGrid="beforeSetupGrid"
      :onRowClicked="onRowClicked"
      navigationPath="onRowClicked"
      navigationField="onRowClicked"
      :selectionEnabled="true"
      :freezeHeader="true"
      name="StudentVoucherStatus"
      :expandedOptions="{
        enabled: true,
        template: 'voucher-change-logs',
      }"
    ></dx-grid>

    <v-dialog v-model="updateDialog" max-width="400">
      <v-card class="pa-2">
        <v-card-title class="headline px-2">Update Voucher Status</v-card-title>

        <div class="px-2 mt-2">
          <v-layout row class="mb-2">
            <div class="font-weight-medium">
              {{
                clickedRow.hebName +
                  " " +
                  clickedRow.lastNameH +
                  " (" +
                  clickedRow.branch +
                  " | " +
                  clickedRow.class +
                  ")"
              }}
            </div>
          </v-layout>
          <v-layout row class="mb-2">
            <div class="font-weight-medium width-150">Father</div>
            <div>{{ clickedRow.hname }}</div>
          </v-layout>
          <v-layout row class="mb-2">
            <div class="font-weight-medium width-150">Address</div>
            <div>
              {{ clickedRow.busAddress1 }}
            </div>
          </v-layout>
          <v-layout row class="mb-2">
            <div class="font-weight-medium width-150">
              Primary Phone
            </div>
            <div>{{ clickedRow.homePhone }}</div>
          </v-layout>
          <v-layout row class="mb-2">
            <div class="font-weight-medium width-150">School</div>
            <div>{{ trimText(clickedRow.school) }}</div>
          </v-layout>
          <div class="mb-2" v-if="trimText(clickedRow.schoolNote)">
            <div class="font-weight-medium">School Note</div>
            <div style="word-break: break-word">
              {{ trimText(clickedRow.schoolNote) }}
            </div>
          </div>
          <v-select
            v-model="clickedRow.voucherStatus"
            label="Voucher Status"
            class="mb-2 mt-3"
            :items="voucherStatuses.map((s) => s.status)"
            clearable
          ></v-select>
          <v-textarea
            v-model="clickedRow.voucherStatusNote"
            label="Note"
            class="mb-3"
            rows="3"
          ></v-textarea>

          <v-text-field
            v-model="clickedRow.caseNumber"
            label="Case Number"
            class="mb-3"
          ></v-text-field
          ><v-text-field
            v-model="clickedRow.caseName"
            label="Case Name"
            class="mb-3"
          ></v-text-field>
          <v-text-field
            v-model="clickedRow.childsLegalName"
            label="Child's Legal Name"
            class="mb-0"
          ></v-text-field>

          <v-checkbox
            class="mt-0 pt-0 mb-3 pb-2"
            v-model="clickedRow.okToRelease"
            label="Ok To Release"
            color="success"
            hide-details
          ></v-checkbox>
        </div>
        <v-card-actions class="pt-0 mr-2 mt-0 pb-2">
          <v-spacer></v-spacer>
          <v-btn dark color="default" @click="updateDialog = false"
            >Cancel</v-btn
          >
          <v-btn :loading="processing" dark color="success" @click="save()">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="voucherStatusDialog" max-width="400">
      <v-card class="pa-2">
        <v-card-title class="headline px-2">Update Voucher Status</v-card-title>
        <div class="px-2 mt-2">
          <div style="overflow-y: auto; height: 300px">
            <div v-for="(student, index) in selected">
              <div class="font-weight-medium">
                {{
                  student.hebName +
                    " " +
                    student.lastNameH +
                    " (" +
                    student.branch +
                    " | " +
                    student.class +
                    ")"
                }}
              </div>
              <div class="caption">Father: {{ student.hname }}</div>
              <div class="caption">
                {{ student.busAddress1 }}
              </div>
              <div class="body-2">
                {{ student.homePhone }}
              </div>
              <v-divider
                class="my-2"
                v-if="index + 1 < selected.length"
              ></v-divider>
            </div>
          </div>

          <v-select
            v-model="voucherStatus"
            label="Voucher Status"
            class="mb-2 mt-3"
            :items="voucherStatuses.map((s) => s.status)"
            clearable
          ></v-select>
          <v-textarea
            v-model="note"
            label="Note"
            hide-details
            class="mb-3"
            rows="3"
          ></v-textarea>
        </div>
        <v-card-actions class="pt-0 mr-2 mt-0 pb-2">
          <v-spacer></v-spacer>
          <v-btn dark color="default" @click="voucherStatusDialog = false"
            >Cancel</v-btn
          >
          <v-btn
            :loading="processing"
            dark
            color="success"
            @click="saveInBulk()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="applicationInfoDialog" max-width="1300" persistent>
      <v-card style="height: 90vh; display: flex; flex-direction: column">
        <v-card-title class="headline success white--text py-2">
          Application Information
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="closeApplicationInfoDialog"
            class="white--text my-0"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-progress-linear
          v-if="applicationInfoLoading"
          class="my-0"
          color="success"
          height="3"
          indeterminate
        ></v-progress-linear>

        <v-card-text class="pa-2" style="flex: 1; overflow-y: auto">
          <div
            class="mb-3 pa-2"
            style="
                            background-color: #f5f5f5;
                            border-radius: 4px;
                            font-size: 12px;
                        "
          >
            <v-layout row wrap>
              <v-flex xs4>
                <div>
                  <span class="font-weight-medium">Name:</span>
                  {{ selectedStudent.hebName }}
                  {{ selectedStudent.lastNameH }}
                </div>
                <div>
                  <span class="font-weight-medium">Father:</span>
                  {{ selectedStudent.hname }}
                </div>
                <div>
                  <span class="font-weight-medium">Address:</span>
                  {{ selectedStudent.busAddress1 }}
                </div>
              </v-flex>
              <v-flex xs4>
                <div>
                  <span class="font-weight-medium">Account ID:</span>
                  {{ selectedStudent.familyID }}
                </div>
                <div>
                  <span class="font-weight-medium">Student ID:</span>
                  {{ selectedStudent.studentID }}
                </div>
              </v-flex>
              <v-flex xs4>
                <div>
                  <span class="font-weight-medium">Home Phone:</span>
                  {{ selectedStudent.homePhone }}
                </div>
                <div>
                  <span class="font-weight-medium">Voucher Status:</span>
                  {{ selectedStudent.voucherStatus }}
                </div>
              </v-flex>
            </v-layout>
          </div>

          <v-layout row wrap>
            <v-flex xs4 class="pr-4">
              <div class="pa-3 mb-3 voucher-info-section">
                <div class="font-weight-bold mb-2" style="font-size: 14px">
                  טאטע
                </div>

                <div class="mb-2">
                  <div class="caption grey--text text--darken-1">
                    טאטע געוואוינט אין
                  </div>
                  <div class="body-2 font-weight-medium">
                    {{ displayValue(applicationInfo.fatherCity) }}
                  </div>
                </div>

                <div class="mb-2">
                  <div class="caption grey--text text--darken-1">
                    ?טאטע איז א תלמיד פון חדר
                  </div>
                  <div class="body-2 font-weight-medium">
                    {{ displayValue(applicationInfo.fatherSchool) }}
                  </div>
                </div>

                <div class="mb-2">
                  <div class="caption grey--text text--darken-1">
                    ?טאטע איז א תלמיד פון ישיבה קטנה
                  </div>
                  <div class="body-2 font-weight-medium">
                    {{ displayValue(applicationInfo.fatherYeshivahKetana) }}
                  </div>
                </div>

                <div>
                  <div class="caption grey--text text--darken-1">
                    ?טאטע איז א תלמיד פון ישיבה גדולה
                  </div>
                  <div class="body-2 font-weight-medium">
                    {{ displayValue(applicationInfo.fatherYeshivahGedolah) }}
                  </div>
                </div>
              </div>

              <div class="pa-3 mb-3 voucher-info-section">
                <div class="font-weight-bold mb-2" style="font-size: 14px">
                  מאמע
                </div>

                <div class="mb-2">
                  <div class="caption grey--text text--darken-1">
                    ?מאמע איז תלמידה פון
                  </div>
                  <div class="body-2 font-weight-medium">
                    {{ displayValue(applicationInfo.motherSchool) }}
                  </div>
                </div>

                <div>
                  <div class="caption grey--text text--darken-1">
                    ?וועלכע יאר גענדיגט די 11 טע קלאס
                  </div>
                  <div class="body-2 font-weight-medium">
                    {{ displayValue(applicationInfo.motherGraduatedYear) }}
                  </div>
                </div>
              </div>

              <div class="pa-3 mb-3 voucher-info-section">
                <div class="font-weight-bold mb-2" style="font-size: 14px">
                  Landlord
                </div>

                <div class="mb-2">
                  <div class="caption grey--text text--darken-1">
                    Landlord
                  </div>
                  <div class="body-2 font-weight-medium">
                    {{ displayValue(applicationInfo.landlord) }}
                  </div>
                </div>

                <div>
                  <div class="caption grey--text text--darken-1">
                    Landlord Phone
                  </div>
                  <div class="body-2 font-weight-medium">
                    {{ displayValue(applicationInfo.landlordPhone) }}
                  </div>
                </div>
              </div>

              <div class="pa-3 mb-3 voucher-info-section">
                <div class="font-weight-bold mb-2" style="font-size: 14px">
                  Emergency Contact
                </div>

                <div class="mb-2">
                  <div class="caption grey--text text--darken-1">
                    Emergency Contact Name
                  </div>
                  <div class="body-2 font-weight-medium">
                    {{ displayValue(applicationInfo.inCaseOfEmergencyName) }}
                  </div>
                </div>

                <div>
                  <div class="caption grey--text text--darken-1">
                    Emergency Contact Phone #
                  </div>
                  <div class="body-2 font-weight-medium">
                    {{ displayValue(applicationInfo.inCaseOfEmergencyPhone) }}
                  </div>
                </div>
              </div>

              <div class="pa-3 mb-3 voucher-info-section">
                <div class="font-weight-bold mb-2" style="font-size: 14px">
                  Country
                </div>

                <div class="body-2 font-weight-medium">
                  {{ displayValue(applicationInfo.country) }}
                </div>
              </div>
            </v-flex>

            <v-flex xs4 class="pr-4">
              <div class="pa-3 mb-3 voucher-info-section">
                <div class="font-weight-bold mb-2" style="font-size: 14px">
                  ארבעט
                </div>

                <div class="font-weight-bold mb-2 mt-2" style="font-size: 13px">
                  טאטע'ס ארבעט
                </div>

                <div class="mb-2">
                  <div class="caption grey--text text--darken-1">
                    ארבעט
                  </div>
                  <div class="body-2 font-weight-medium">
                    {{ displayValue(applicationInfo.workPlaceOrBoss) }}
                  </div>
                </div>

                <div class="mb-2">
                  <div class="caption grey--text text--darken-1">
                    נאמען פון בעה''ב
                  </div>
                  <div class="body-2 font-weight-medium">
                    {{ displayValue(applicationInfo.workBoss) }}
                  </div>
                </div>

                <div class="mb-2">
                  <div class="caption grey--text text--darken-1">
                    Work Type
                  </div>
                  <div class="body-2 font-weight-medium">
                    {{ displayValue(applicationInfo.workType) }}
                  </div>
                </div>

                <div class="mb-2">
                  <div class="caption grey--text text--darken-1">
                    Work Address
                  </div>
                  <div class="body-2 font-weight-medium">
                    {{ displayValue(applicationInfo.workAddress) }}
                  </div>
                </div>

                <div class="mb-2">
                  <div class="caption grey--text text--darken-1">
                    Work Phone #
                  </div>
                  <div class="body-2 font-weight-medium">
                    {{ displayValue(applicationInfo.workPhone) }}
                  </div>
                </div>

                <div class="mb-2">
                  <div class="caption grey--text text--darken-1">
                    Work Position
                  </div>
                  <div class="body-2 font-weight-medium">
                    {{ displayValue(applicationInfo.workPosition) }}
                  </div>
                </div>

                <div>
                  <div class="caption grey--text text--darken-1">
                    Years In Position
                  </div>
                  <div class="body-2 font-weight-medium">
                    {{ displayValue(applicationInfo.yearsInPosition) }}
                  </div>
                </div>

                <div class="font-weight-bold mb-2 mt-3" style="font-size: 13px">
                  מאמע'ס ארבעט
                </div>

                <div class="mb-2">
                  <div class="caption grey--text text--darken-1">
                    ארבעט
                  </div>
                  <div class="body-2 font-weight-medium">
                    {{ displayValue(applicationInfo.wifeWorkPlaceOrBoss) }}
                  </div>
                </div>

                <div class="mb-2">
                  <div class="caption grey--text text--darken-1">
                    נאמען פון בעה''ב
                  </div>
                  <div class="body-2 font-weight-medium">
                    {{ displayValue(applicationInfo.wifeWorkBoss) }}
                  </div>
                </div>

                <div class="mb-2">
                  <div class="caption grey--text text--darken-1">
                    Work Type
                  </div>
                  <div class="body-2 font-weight-medium">
                    {{ displayValue(applicationInfo.wifeWorkType) }}
                  </div>
                </div>

                <div class="mb-2">
                  <div class="caption grey--text text--darken-1">
                    Work Address
                  </div>
                  <div class="body-2 font-weight-medium">
                    {{ displayValue(applicationInfo.wifeWorkAddress) }}
                  </div>
                </div>

                <div class="mb-2">
                  <div class="caption grey--text text--darken-1">
                    Work Phone #
                  </div>
                  <div class="body-2 font-weight-medium">
                    {{ displayValue(applicationInfo.wifeWorkPhone) }}
                  </div>
                </div>

                <div class="mb-2">
                  <div class="caption grey--text text--darken-1">
                    Work Position
                  </div>
                  <div class="body-2 font-weight-medium">
                    {{ displayValue(applicationInfo.wifeWorkPosition) }}
                  </div>
                </div>

                <div>
                  <div class="caption grey--text text--darken-1">
                    Years In Position
                  </div>
                  <div class="body-2 font-weight-medium">
                    {{ displayValue(applicationInfo.wifeYearsInPosition) }}
                  </div>
                </div>
              </div>
            </v-flex>

            <v-flex xs4>
              <div class="pa-3 mb-3 voucher-info-section">
                <div class="font-weight-bold mb-2" style="font-size: 14px">
                  ביהמ"ד
                </div>

                <div class="mb-2">
                  <div class="caption grey--text text--darken-1">
                    וואכן ביהמ''ד
                  </div>
                  <div class="body-2 font-weight-medium">
                    {{ displayValue(applicationInfo.shabbatSynagogue) }}
                  </div>
                </div>

                <div class="mb-2">
                  <div class="caption grey--text text--darken-1">
                    שבת ביהמ''ד
                  </div>
                  <div class="body-2 font-weight-medium">
                    {{ displayValue(applicationInfo.weekdaySynagogue) }}
                  </div>
                </div>

                <div class="mb-2">
                  <div class="caption grey--text text--darken-1">
                    דיין
                  </div>
                  <div class="body-2 font-weight-medium">
                    {{ displayValue(applicationInfo.dayan) }}
                  </div>
                </div>

                <div>
                  <div class="caption grey--text text--darken-1">
                    קיט''ל מעמבער
                  </div>
                  <div class="body-2 font-weight-medium">
                    {{ displayYesNo(applicationInfo.isSatmarMember) }}
                  </div>
                </div>
              </div>

              <div class="pa-3 mb-3 voucher-info-section">
                <div class="font-weight-bold mb-2" style="font-size: 14px">
                  קינדער
                </div>

                <div class="mb-2">
                  <div class="caption grey--text text--darken-1">
                    ?וויפיל קינדער האט איר אין שטוב
                  </div>
                  <div class="body-2 font-weight-medium">
                    {{ displayValue(applicationInfo.kidsAtHome) }}
                  </div>
                </div>

                <div class="mb-2">
                  <div class="caption grey--text text--darken-1">
                    ?האט איר קינדער אין אנדערע מוסדות
                  </div>
                  <div class="body-2 font-weight-medium">
                    {{ displayYesNo(applicationInfo.kidsInOtherSchool) }}
                  </div>
                </div>

                <div class="mb-2">
                  <div class="caption grey--text text--darken-1">
                    נאמען פון מוסד
                  </div>
                  <div class="body-2 font-weight-medium">
                    {{ displayValue(applicationInfo.otherSchool) }}
                  </div>
                </div>

                <div>
                  <div class="caption grey--text text--darken-1">
                    Play Group
                  </div>
                  <div class="body-2 font-weight-medium">
                    {{ displayValue(applicationInfo.playGroup) }}
                  </div>
                </div>
              </div>

              <div class="pa-3 mb-3 voucher-info-section">
                <div class="font-weight-bold mb-2" style="font-size: 14px">
                  Benefits &amp; Programs
                </div>

                <div class="mb-2">
                  <div class="caption grey--text text--darken-1">
                    Food Stamp Case #
                  </div>
                  <div class="body-2 font-weight-medium">
                    {{ displayValue(applicationInfo.foodStampCase) }}
                  </div>
                </div>

                <div class="mb-2">
                  <div class="caption grey--text text--darken-1">
                    Vouchers
                  </div>
                  <div class="body-2 font-weight-medium">
                    {{ displayValue(applicationInfo.vouchers) }}
                  </div>
                </div>

                <div>
                  <div class="caption grey--text text--darken-1">
                    Note
                  </div>
                  <div
                    class="body-2 font-weight-medium"
                    style="white-space: pre-wrap"
                  >
                    {{ displayValue(applicationInfo.note) }}
                  </div>
                </div>
              </div>
            </v-flex>
          </v-layout>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="py-2 pr-1 my-2" style="flex-shrink: 0">
          <v-spacer></v-spacer>
          <v-btn color="default" dark @click="closeApplicationInfoDialog">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
import { loadOptions } from "../../utils/smLookup.js";

export default {
  data: () => ({
    title: "Student Voucher Status",

    actions: [],
    userBranch: "",
    url: "",
    regID: "",

    processing: false,
    selected: [],
    updateDialog: false,
    voucherStatusDialog: false,
    clickedRow: {},
    voucherStatuses: [],
    voucherStatus: "",
    note: "",
    filter: "",

    applicationInfoDialog: false,
    applicationInfoLoading: false,
    applicationInfo: {},
    selectedStudent: {},

    rules: {
      required: (value) => !!value || "Required.",
    },

    columns: [
      {
        label: "Last Name",
        field: "lastName",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "First Name",
        field: "engName",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Last Name H",
        field: "lastNameH",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "First Name H",
        field: "hebName",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Student ID",
        field: "studentID",
        link: "StudentView",
        format: "",
        template: "link-cell-template",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        field: "familyID",
        label: "Account ID",
        link: "Account View",
        format: "",
        template: "link-action-cell-template",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
        showLink: (row) => {
          return true;
        },
      },
      {
        label: "Voucher Status",
        field: "voucherStatus",
        template: "text-color-cell-template",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Ok To Release",
        field: "okToRelease",
        format: "",
        visible: true,
        type: "boolean",
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Note",
        field: "voucherStatusNote",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Case Number",
        field: "caseNumber",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Case Name",
        field: "caseName",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Childs Legal Name",
        field: "childsLegalName",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Family Case Number",
        field: "caseNo",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "VType",
        field: "vType",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Applicant Info Fields",
        field: "applicantInfoCount",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
        template: "link-action-cell-template",
        showLink: (row) => {
          return true;
        },
      },
      {
        label: "School",
        field: "school",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "School Note",
        field: "schoolNote",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Start Date",
        field: "startDate",
        type: "date",
        format: "MM/dd/yyyy",
        visible: true,
        sortOrder: "desc",
        sortIndex: 0,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Building",
        field: "building",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Branch",
        field: "branch",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Grade",
        field: "class",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Section",
        field: "section",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "DOB",
        field: "dob",
        type: "date",
        format: "MM/dd/yyyy",
        visible: true,
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Age",
        field: "age",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Home Phone",
        field: "homePhone",
        format: "",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Address",
        field: "address1",
        format: "",
        visible: false,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Is Applicant",
        field: "isApplicant",
        format: "",
        type: "boolean",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      // {
      //     label: "Family Voucher Count",
      //     field: "familyVoucherCount",
      //     format: "",
      //     visible: true,
      //     filterType: "",
      //     filterValues: [],
      //     filterValue: null,
      //     selectedFilterOperation: null,
      // },
      {
        label: "Family Has Vouchers",
        field: "familyHasVouchers",
        format: "",
        type: "boolean",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Has Voucher",
        field: "hasVoucher",
        format: "",
        type: "boolean",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
      {
        label: "Has Only Applicant Students",
        field: "hasOnlyApplicantStudents",
        format: "",
        type: "boolean",
        visible: true,
        filterType: "",
        filterValues: [],
        filterValue: null,
        selectedFilterOperation: null,
      },
    ],
  }),
  watch: {},
  async created() {
    this.columns.find((c) => c.field == "familyID").linkAction = (account) => {
      this.toAccount(account);
    };

    this.columns.find((c) => c.field == "applicantInfoCount").linkAction = (
      row
    ) => {
      this.openApplicationInfoDialog(row);
    };
  },
  beforeDestroy() {},
  methods: {
    async beforeSetupGrid() {
      this.userBranch = this.$store.state.authentication.branch;

      await this.loadVoucherStatuses();

      this.columns.find((c) => c.field == "voucherStatus").getTextColor = (
        value,
        row
      ) => {
        if (!value) return;

        const vhStatus = this.voucherStatuses.find((s) => s.status == value);

        return vhStatus && vhStatus.color ? vhStatus.color : "";
      };

      this.actions.push({
        text: "Update Voucher Status",
        action: this.openVoucherStatus,
        showOnSelection: true,
      });

      let url =
        "voucherStudentStatus?" +
        (this.userBranch != "null" ? "branch=" + this.userBranch : "branch=");

      await this.loadRegID();

      const terms = await this.getTerms();

      this.actions.push({
        text: "Select Filter",
        placeholder: "Select Filter",
        type: "select",
        values: ["New Family – Missing Status", "Voucher Family – Missing Status"],
        value: this.filter,
        onSelected: this.onFilterSelected,
        clearable: true,
        width: "250px",
      });

      this.actions.push({
        text: "Select Term",
        type: "select",
        values: terms,
        value: this.regID,
        onSelected: this.onTermSelected,
      });

      this.url = url +=
        "&regID=" +
        this.regID +
        "&onlyApplicantEmptyStatus=&hasVoucherEmptyStatus=";
    },
    async loadRegID() {
      this.regID = await this.$http.get("api/allStudents/getUpcomingYearRegID");
    },
    async getTerms() {
      return await this.$http.get("api/allStudents/getRegTerms");
    },
    async loadVoucherStatuses() {
      const statuses = await this.$http.get(
        "api/VoucherStudentStatus/GetVoucherStatuses"
      );

      this.voucherStatuses = statuses.sort((a, b) => a.sortOrder - b.sortOrder);
    },
    onTermSelected(value) {
      this.regID = value;

      let url =
        "voucherStudentStatus?" +
        (this.userBranch != "null" ? "branch=" + this.userBranch : "branch=");

      this.url = url +=
        "&regID=" +
        this.regID +
        "&onlyApplicantEmptyStatus=" +
        this.getOnlyApplicantEmptyStatusFilter() +
        "&hasVoucherEmptyStatus=" +
        this.getHasVoucherEmptyStatusFilter();

      this.$refs.grid.reloadDataSource(this.url);
    },
    onFilterSelected(value) {
      this.filter = value;

      let url =
        "voucherStudentStatus?" +
        (this.userBranch != "null" ? "branch=" + this.userBranch : "branch=");

      this.url = url +=
        "&regID=" +
        this.regID +
        "&onlyApplicantEmptyStatus=" +
        this.getOnlyApplicantEmptyStatusFilter() +
        "&hasVoucherEmptyStatus=" +
        this.getHasVoucherEmptyStatusFilter();

      this.$refs.grid.reloadDataSource(this.url);
    },
    getOnlyApplicantEmptyStatusFilter() {
      return this.filter == "New Family – Missing Status";
    },
    getHasVoucherEmptyStatusFilter() {
      return this.filter == "Voucher Family – Missing Status";
    },
    toAccount(row) {
      this.$router.push({
        name: "Account View",
        params: {
          id: row.familyID,
        },
        query: {
          limitView: true,
        },
      });
    },
    onRowClicked(row) {
      this.clickedRow = JSON.parse(JSON.stringify(row));

      this.updateDialog = true;
    },
    openVoucherStatus() {
      this.selected = JSON.parse(
        JSON.stringify(this.$refs.grid.getSelectedRowsData())
      );

      this.voucherStatusDialog = true;
    },
    showLink() {
      return (
        !this.$store.state.authentication.branch ||
        this.$store.state.authentication.branch == "null"
      );
    },
    async openApplicationInfoDialog(row) {
      this.selectedStudent = JSON.parse(JSON.stringify(row));
      this.applicationInfo = {};
      this.applicationInfoDialog = true;
      this.applicationInfoLoading = true;

      try {
        const response = await this.$http.get(
          "api/newfamilyapplications/GetApplicationByAccountID?accountid=" +
            (row.familyID ? row.familyID.trim() : "")
        );

        this.applicationInfo = response || {};
      } catch (e) {
        this.applicationInfo = {};

        this.$notify({
          text: "Error loading application information",
          group: "notification",
          type: "error",
        });
      } finally {
        this.applicationInfoLoading = false;
      }
    },
    closeApplicationInfoDialog() {
      this.applicationInfoDialog = false;
      this.applicationInfo = {};
      this.selectedStudent = {};
    },
    trimText(value) {
      return value ? String(value).trim() : "";
    },
    displayValue(value) {
      return value || value === 0 ? value : "-";
    },
    displayYesNo(value) {
      return value ? "Yes" : "No";
    },
    async save() {
      try {
        this.processing = true;

        const today = moment().format("YYYY-MM-DD HH:mm:ss");

        await this.$http.post("api/allStudents/saveVoucherStatus", [
          {
            studentID: this.clickedRow.studentID,
            status: this.clickedRow.voucherStatus,
            note: this.clickedRow.voucherStatusNote,
            caseNumber: this.clickedRow.caseNumber,
            caseName: this.clickedRow.caseName,
            childsLegalName: this.clickedRow.childsLegalName,
            okToRelease: this.clickedRow.okToRelease,
            lastUpdated: today,
            updatedBy: this.$store.state.authentication.user,
          },
        ]);

        this.processing = false;
        this.updateDialog = false;

        this.$notify({
          text: "Changes Saved",
          group: "notification",
          type: "success",
        });

        this.$refs.grid.reloadGrid();
      } catch (e) {
        this.processing = false;
      }
    },
    async saveInBulk() {
      try {
        this.processing = true;

        const today = moment().format("YYYY-MM-DD HH:mm:ss");

        await this.$http.post(
          "api/allStudents/saveVoucherStatus",
          this.selected.map((student) => ({
            studentID: student.studentID,
            status: this.voucherStatus,
            note: this.note,
            lastUpdated: today,
            updatedBy: this.$store.state.authentication.user,
          }))
        );

        this.voucherStatus = "";
        this.note = "";
        this.processing = false;
        this.voucherStatusDialog = false;

        this.$notify({
          text: "Changes Saved",
          group: "notification",
          type: "success",
        });

        this.$refs.grid.reloadGrid();
      } catch (e) {
        this.processing = false;
      }
    },
  },
};
</script>
<style>
[v-cloak] {
  display: none;
}
.v-btn__content {
  color: unset;
}
.voucher-info-section {
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 6px;
}
</style>
